/* @ngInject */
function CreateCampaignDialogController ($scope, CampaignService, ToastService, SegmentService) {
  const api = {
    _successCreateCampaign,
    _errorCreateCampaign
  }

  this.getApi = () => api

  $scope.campaign = {
    title: '',
    status: 'WAITING',
    startDate: $scope.data?.startDateCalendar || null,
    deliveryDate: $scope.data?.endDateCalendar || null,
    publicAccess: 'allUsers',
    expireCampaignContentsOnFinish: $scope.data?.expireCampaignContentsOnFinish || false
  }

  $scope.flags = {
    loading: false
  }

  $scope.selectedTab = 'briefing'

  activate()

  function activate () {
  }

  $scope.onChangeCampaignName = event => {
    const value = event?.detail?.value
    $scope.campaign.name = value
  }

  $scope.onStartDateChange = (event) => {
    const startDate = event?.detail?.date
    $scope.campaign.startDate = startDate
  }

  $scope.onDeliveryDateChange = (event) => {
    const endDate = event?.detail?.date
    $scope.campaign.deliveryDate = endDate
  }

  $scope.onChangeExpireContentOnCampaignFinish = (event) => {
    $scope.campaign.expireCampaignContentsOnFinish = event?.detail?.value ?? false
  }

  $scope.goToAccessTab = () => {
    $scope.selectedTab = 'access'
  }

  $scope.isCreateCampaignButtonEnabled = (campaign) => {
    if (!campaign.name || !campaign.startDate || !campaign.deliveryDate) {
      return false
    }

    return true
  }

  $scope.createCampaign = () => {
    $scope.flags.loading = true
    CampaignService.createCampaign({
      title: $scope.campaign.name,
      status: $scope.campaign.status,
      groupIds: $scope.campaign.groupIds,
      startDate: $scope.campaign.startDate,
      deliveryDate: $scope.campaign.deliveryDate,
      expireCampaignContentsOnFinish: $scope.campaign.expireCampaignContentsOnFinish
    })
      .then((response) => {
        SegmentService.track('campaign-create', {
          campaign_id: response.id
        })
        api._successCreateCampaign()
      })
      .catch(api._errorCreateCampaign)
      .finally(() => {
        $scope.flags.loading = false
      })
  }

  function _successCreateCampaign () {
    ToastService.defaultSuccessToast()
    $scope.close()
  }

  function _errorCreateCampaign () {
    ToastService.defaultErrorToast()
  }
}

export { CreateCampaignDialogController }
